import { render, staticRenderFns } from "./FormWizardCustomText.vue?vue&type=template&id=06ea6cc0"
import script from "./FormWizardCustomText.vue?vue&type=script&lang=js"
export * from "./FormWizardCustomText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports